<div id="main-navigation" class="nav vertical">
  <div class="group-items">
    @for (navItem of navigation; track navItem.url) { @if (navItem.externalLink || navItem.controlAdminOnly ||
    (permissionsService.hasPermissionAsync(navItem.permission) | async)) {
    <lin-nav-item [navItem]="navItem"></lin-nav-item>
    } }
  </div>
</div>
